import { STEPS } from "@/config/siteConfig";
import { Reveal, SectionHeading } from "@/components/Reveal";

export const HowItWorks = () => (
  <section className="bg-warm py-16 sm:py-24 lg:py-28" data-testid="how-it-works">
    <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        label="How It Works"
        title="Your Property Journey, Made Simple"
        subtitle="From your first enquiry to your property decision, we’re here to guide you."
      />

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative">
        <div className="hidden lg:block absolute top-[26px] left-[12%] right-[12%] h-px bg-gold/40" aria-hidden="true" />
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.12}>
            <div className="relative text-center" data-testid={`how-step-${s.num}`}>
              <div className="relative z-10 mx-auto h-[52px] w-[52px] rounded-full bg-navy border-2 border-gold flex items-center justify-center">
                <span className="font-display text-lg font-semibold text-gold">{s.num}</span>
              </div>
              <h3 className="mt-5 font-display text-lg sm:text-xl font-semibold text-navy">{s.title}</h3>
              <p className="mt-2 text-[13px] sm:text-sm text-ink-soft leading-relaxed max-w-[240px] mx-auto">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
